module.exports = __webpack_public_path__ + "static/Century_21_logo-f7e87326b1f53dde4654b26c71cabada.webp";